import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Home from '../views/Home.vue'
import Cases from '../views/Cases.vue'
import Videos from '../views/Videos.vue'
import Exams from '../views/Exams.vue'
import Students from '../views/Students.vue'
import StudentHome from '../views/StudentHome.vue'
import ExamResult from '../views/ExamResult.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/login' },
  { 
    path: '/login', 
    component: Login,
    meta: { requiresAuth: false }
  },
  { 
    path: '/home', 
    component: Home,
    meta: { requiresAuth: true, role: 'ADMIN' }
  },
  { 
    path: '/cases', 
    component: Cases,
    meta: { requiresAuth: true, role: 'ADMIN' }
  },
  { 
    path: '/videos', 
    component: Videos,
    meta: { requiresAuth: true, role: 'ADMIN' }
  },
  { 
    path: '/exams', 
    component: Exams,
    meta: { requiresAuth: true, role: 'ADMIN' }
  },
  { 
    path: '/students', 
    component: Students,
    meta: { requiresAuth: true, role: 'ADMIN' }
  },
  { 
    path: '/student',
    alias: '/academy',
    component: StudentHome,
    meta: { requiresAuth: true, role: 'STUDENT' }
  },
  { 
    path: '/exam-result', 
    component: ExamResult,
    meta: { requiresAuth: true, role: 'STUDENT' }
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

// 全局前置守卫
router.beforeEach((to, from, next) => {
  // 检查用户是否已登录
  const userInfo = localStorage.getItem('userInfo')
  const user = userInfo ? JSON.parse(userInfo) : null
  const isAdmin = user && user.role === 'ADMIN'
  const homePath = isAdmin ? '/cases' : '/academy'
  
  // 如果目标页面不需要认证，直接放行
  if (to.meta.requiresAuth === false) {
    // 已登录的用户访问登录页，根据角色跳转
    if (user) {
      next(homePath)
    } else {
      next()
    }
    return
  }
  
  // 如果需要认证但未登录，跳转到登录页
  if (!userInfo && to.path !== '/login') {
    next('/login')
    return
  }
  
  // 检查权限
  if (to.meta.role) {
    const hasRole = user.role === to.meta.role || (to.meta.role === 'STUDENT' && user.role === 'ACADEMY')
    if (!hasRole) {
      // 没有权限，跳转到自己的首页
      next(homePath)
      return
    }
  }
  
  // 已登录，允许访问
  next()
})

export default router
